import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '@/config';
import { prepareHeaders } from '@/configuration/tokenHandling/prepareHeaders';
import {
    GetVehicleStatusData,
    GetVehicleStatusDataCsv,
    GetVehicleStatusGlobalCounters,
} from '@/generated/GeneratedApiTypes';

export const vehicleStatusApi = createApi({
    reducerPath: 'vehicleStatusApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.BACKEND_URI, prepareHeaders }),
    endpoints: (build) => ({
        getVehicleStatusGlobalCounters: build.query<
            GetVehicleStatusGlobalCounters.GetVehicleStatusGlobalCounters.ResponseBody,
            GetVehicleStatusGlobalCounters.GetVehicleStatusGlobalCounters.RequestBody
        >({
            query: (queryArg) => ({
                url: '/get-vehicle-status-global-counters',
                method: 'POST',
                body: queryArg,
                responseHandler: async (response) => response.json(),
            }),
        }),
        getVehicleStatusData: build.query<
            GetVehicleStatusData.GetVehicleStatusData.ResponseBody,
            GetVehicleStatusData.GetVehicleStatusData.RequestBody
        >({
            query: (queryArg) => ({
                url: '/get-vehicle-status-data',
                method: 'POST',
                body: queryArg,
                responseHandler: async (response) => response.json(),
            }),
        }),
        getVehicleStatusDataCsv: build.mutation<
            GetVehicleStatusDataCsv.GetVehicleStatusDataCsv.ResponseBody,
            GetVehicleStatusDataCsv.GetVehicleStatusDataCsv.RequestBody
        >({
            query: (queryArg) => ({
                url: '/get-vehicle-status-data-csv',
                method: 'POST',
                body: queryArg,
                responseHandler: async (response) => response.blob(),
            }),
        }),
    }),
});

export const {
    useGetVehicleStatusGlobalCountersQuery,
    useGetVehicleStatusDataQuery,
    useGetVehicleStatusDataCsvMutation,
} = vehicleStatusApi;
